import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import selector from '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import StyledIcon from '../Icon/styled.js';
import _Heading from 'reakit/Heading';

var subHeadingProperties = css(["font-weight:", ";&{", ";}"], theme('fannypack.fontWeights.semibold'), theme('fannypack.Heading.subHeading'));
var Heading = styled(_Heading).withConfig({
  displayName: "styled__Heading",
  componentId: "cya4kb-0"
})(["font-weight:", ";line-height:1.2;&:not(:last-child){margin-bottom:", "rem;}.heading& + .sub-heading{margin-top:-1rem;}h1&{font-size:", "rem;&{", ";}}h2&{font-size:", "rem;&{", ";}}h3&{font-size:", "rem;&{", ";}}h4&{font-size:", "rem;&{", ";}}h5&{font-size:", "rem;&{", ";}}h6&{font-size:", "rem;&{", ";}}& ", "{top:0.15em;}&{", ";}", ";"], theme('fannypack.fontWeights.bold'), space(4), theme('fannypack.fontSizes.700'), theme('fannypack.Heading.h1'), theme('fannypack.fontSizes.600'), theme('fannypack.Heading.h2'), theme('fannypack.fontSizes.500'), theme('fannypack.Heading.h3'), theme('fannypack.fontSizes.400'), theme('fannypack.Heading.h4'), theme('fannypack.fontSizes.300'), theme('fannypack.Heading.h5'), theme('fannypack.fontSizes.200'), theme('fannypack.Heading.h6'), selector(StyledIcon), function (props) {
  return props.isSubHeading && subHeadingProperties;
}, theme('fannypack.Heading.base'));

export default Heading;
export { Heading, subHeadingProperties };
